<!--厕所评价-->
<template>
  <div class="page-content">
    <div class="wcev-content">

      <!-- <div  v-if="wc.iconPath !== '' || wc.iconPath !== null">
        <van-image :src="wc.iconPath" alt="" />
      </div>
       <div v-else>
        <img :src="noListIcon" alt="" />
      </div> -->
      <div class="wcev-title">{{ wc.toiletName }}</div>
      <div v-for="(item, i) in options" :key="'wcev-key-' + i" class="wcev-item">
        <div class="wcev-label">{{ item.option }}</div>
        <div v-for="(v, k) in 5" :key="'wcev-key-start-' + k" @touchstart="startClick(i, v)">
          <img :src="v <= item.start ? find_wc_l : find_wc_d" alt="">
        </div>
      </div>
    </div>
    <div class="wcev-submit" @click="submit">
      提交
    </div>
  </div>
</template>
<script>
// import { mapState, mapActions } from 'vuex'
import { Dialog } from 'vant';
import qs from 'qs';
import axios from 'axios';
export default {
  data() {
    return {
      options: [
        { option: '环境', start: 0 },
        { option: '气味', start: 0 },
        { option: '卫生', start: 0 },
      ],
      find_wc_l: require('../../assets/iconImage/findwc_start_l.png'),
      find_wc_d: require('../../assets/iconImage/findwc_start_d.png'),
      isSubmit: false,
      uid: this.$cookie.get('w_uid'),
      wc: {},
    };
  },
  components: {
    [Dialog.Component.name]: Dialog.Component,
  },
  created() { },
  methods: {
    startClick(index, sta) {
      console.log(index, '行数');
      console.log(sta, '星级');
      const options = this.options;
      const option = options[index];
      const start = option.start;
      if (sta > start) {
        option.start = sta;
      } else {
        option.start = sta - 1;
      }
      options[index] = option;
      this.options = options;
    },
    submit() {
      if (!this.isSubmit) {
        this.isSubmit = true;
        if (
          this.options[1].start === 0 ||
          this.options[0].start === 0 ||
          this.options[2].start === 0
        ) {
          this.isSubmit = false;
          return this.$toast({
            message: '请做出完整评价',
            duration: '2000',
          });
        }
        // ${qs.stringify({
        //     toiletId: this.$route.query.wc_id,
        //     userId: localStorage.getItem('uid'),
        //     environmentMark: this.options[0].start,
        //     smellMark: this.options[1].start,
        //     healthMark: this.options[2].start,
        //   })}
        // let data = new FormData();
        // data.append('toiletId', this.$route.query.wc_id);
        // data.append('userId', localStorage.getItem('uid'));
        // data.append('environmentMark', this.options[0].start);
        // data.append('smellMark', this.options[1].start);
        // data.append('healthMark', this.options[2].start);
        // console.log(data,'datadata')
        axios.create({
          baseURL: this.newUrlHost,
          headers: {},
          withCredentials: true,
        }).get(`/appserver/v1/toilet/toiletComment?toiletId=${this.$route.query.wc_id}&smellMark=${this.options[1].start}&environmentMark=${this.options[0].start}&healthMark=${this.options[2].start}`).then(res => {
          this.isSubmit = false;
          if (res.ret == 0) {
            this.$toast({
              message: '提交成功',
              duration: '5000',
            });
          } else {
            Dialog.confirm({
              title: '评价',
              message: res.data.data,
              confirmButtonColor: '#2EBA73',
              showCancelButton: false,
            }).then(() => {
              if (res.errorcode == 2002) {  // 用户未登录
                this.wxAuth();
              } else if (res.errorcode == 2003) {  // 一天只能评论一次
                this.$router.replace({
                  path: '/wcDetail',
                  query: {
                    wc_id: this.$route.query.wc_id,
                  },
                });
              } else { // 评价失败
                this.$router.replace({
                  path: '/wcDetail',
                  query: {
                    wc_id: this.$route.query.wc_id,
                  },
                });
              }
            });
          }
        });
      }
    },
  },
  mounted() {
    axios.create({
      baseURL: this.newUrlHost,
      headers: {},
      withCredentials: true,
    }).get(`/appserver/v1/toilet/detail?toiletId=${this.$route.query.wc_id}`).then(res => {
      // console.log(res)
      if (res.status === 200) {
        this.wc = res.data ? res.data.data : {};
      }
    });
  },
};
</script>
<style lang="scss">
.page-content {
  width: 100%;
  height: 100%;
  .wcev-content {
    width: 100%;
    height: calc(100% - 60px);
    padding-left: 20px;
    box-sizing: border-box;
    // padding: 10px 20px;
    // box-sizing: border-box;
    .van-image {
      padding: 10px;
    }
    img {
      width: 100%;
      height: 210px;
      border-radius: 2px;
      border: none;
    }
    /deep/ .van-image__img {
      width: 100%;
      height: 210px;
      border-radius: 2px;
      border: none;
    }
    .wcev-title {
      padding: 20px 10px;
      font-size: 17px;
      font-family: PingFang-SC-Bold, PingFang-SC;
      font-weight: bold;
      color: rgba(34, 34, 34, 1);
      line-height: 17px;
    }
    .wcev-item {
      display: flex;
      align-items: center;
      margin-bottom: 16px;
      padding: 0 10px;
      .wcev-label {
        font-size: 12px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #63666f;
        line-height: 15px;
        margin-right: 26px;
      }
      img {
        width: 24px;
        height: 24px;
        margin-right: 14px;
      }
    }
  }
  .wcev-submit {
    height: 40px;
    margin: 0 20px;
    background: #2eba73;
    font-size: 15px;
    font-family: PingFangSC-Semibold, PingFang SC;
    font-weight: 600;
    color: rgba(255, 255, 255, 1);
    line-height: 40px;
    text-align: center;
  }
}
</style>
